export default {
    AUTISMO: 3,
    OUTRO: 13,
}